/**
 * The server's count of what deleting a competition day would destroy, turned
 * into the lines a confirmation lists.
 *
 * Shared by the two screens that can delete a day — the competitions list and
 * the advanced wizard — because the two must not describe the same deletion
 * differently, and because this is the only part of that dialog worth unit
 * testing. It is pure: `summary` is the object
 * `DELETE /tournaments/{id}` returns beside `requires_force`.
 *
 * A zero is left OUT rather than printed. "0 bets" is noise in a list whose
 * whole job is to be read in the two seconds before someone types DELETE.
 */
const plural = (n, one, many) => `${n} ${n === 1 ? one : many}`;

export const deleteSummaryItems = (summary) => {
  if (!summary) return [];
  const items = [];

  if (summary.players) items.push(`${plural(summary.players, 'player', 'players')} entered`);

  if (summary.cards) {
    // Both figures on one line: the total is the size of the day, the scored
    // count is WHY the delete was refused.
    const scored = summary.scored_cards || 0;
    items.push(scored
      ? `${plural(summary.cards, 'scorecard', 'scorecards')}, ${scored} already scored`
      : plural(summary.cards, 'scorecard', 'scorecards'));
  }

  if (summary.hole_scores) items.push(plural(summary.hole_scores, 'hole score', 'hole scores'));
  if (summary.bets) items.push(plural(summary.bets, 'bet', 'bets'));

  return items;
};

export default deleteSummaryItems;
